<template>
  <div class="page-con">
    <div class="list-box common-shadow clearfix">
      <iframe ref="mapFrame"
              :style="fullScreen ? 'width:100%;height:100vh;position: fixed;left: 0;top: 0;z-index: 9999;':'width:100%;height:100vh;'"
              frameborder=0
              name="showHere" scrolling="no" :src="`${publicPath}carInfo/fwShip.html`"></iframe>
    </div>
  </div>
</template>
<script>
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'fwShip',
    data() {
      return {
        fullScreen: true,
        publicPath: process.env.BASE_URL,
      }
    },
    created() {
      let that = this;
      let mmsi = this.$route.params.mmsi;
      if (mmsi) {
        let obj = {
          mmsi: mmsi
        };
        this.sendFrameData(JSON.stringify(obj));
      }
      this.$nextTick(function () {
        window.addEventListener('message', (e) => {
              //前一页传来的数据默认传入到frame中
              that.sendFrameData(e.data)
        })
      })
    },
    methods: {
      sendFrameData(data) {
        showLoading();
        let that = this;
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow
            iframeWin.postMessage(data, '*')
            hideLoading();
          }, 500);
        });
      }
    }
  }
</script>
<style>

</style>
